var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentralized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37512 30.5991H25.6249M6.4455 3.76956H5C2.92894 3.76956 1.25 5.4485 1.25 7.51956V21.4059C1.25 23.477 2.92894 25.1559 5 25.1559H27C29.0674 25.1559 30.744 23.483 30.7499 21.417M30.75 15.1671V7.51956C30.75 5.4485 29.0711 3.76956 27 3.76956H25.5837M20.6916 30.5991H11.3084L13.1834 25.1559H18.8166L20.6916 30.5991Z",
    stroke: "url(#paint0_linear_58_1165)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56987 6.79719H25.3677M16.9861 12.7784H20.159M16.9861 17.9993H20.159M25.4841 25.1559H6.51599V3.99338C6.51599 2.56163 7.67668 1.40094 9.10843 1.40094H22.8917C24.3234 1.40094 25.4841 2.56163 25.4841 3.99338V25.1559Z",
    stroke: "url(#paint1_linear_58_1165)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_1165",
    x1: 1.08725,
    y1: 17.1844,
    x2: 30.9128,
    y2: 17.1844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_1165",
    x1: 6.41135,
    y1: 13.2785,
    x2: 25.5888,
    y2: 13.2785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralized);
export default __webpack_public_path__ + "static/media/Centralized.b19b6b17600b5b2355e1338386da3107.svg";
export { ForwardRef as ReactComponent };